import React from "react";
import "./Spinner.css";
const Spinner = () => /* @__PURE__ */ React.createElement("svg", { className: "spinner" }, /* @__PURE__ */ React.createElement("circle", { cx: "20", cy: "20", r: "18" }));
export default Spinner;
